<form [formGroup]="form" class="row">
    <!-- Caso rolGuardia  -->
  
     <div class="col-12 ">
        <p>Datos del gerente de servicios de asesoria</p>
     </div>
     <div class="col-4">
        <mat-form-field class="wid"  appearance="outline" >
            <mat-label>Nombres y apellidos personal</mat-label>
            <input formControlName="nombre"  matInput>
          </mat-form-field>
     </div>
     <div class="col-4">
        <mat-form-field class="wid"  appearance="outline" >
            <mat-label>Cargo</mat-label>
            <input formControlName="cargo"  matInput>
          </mat-form-field>
     </div>
     <div class="col-4">
        <mat-form-field class="wid"  appearance="outline" >
            <mat-label>NM</mat-label>
            <input formControlName="NM"  matInput>
          </mat-form-field>
     </div>
     <div class="col-12" >
        <mat-form-field class="wid" appearance="outline" >
            <mat-label>Descripción</mat-label>
            <textarea matInput placeholder="Descripción de la asesoría..." formControlName="descripcion" ></textarea>
        </mat-form-field>
     </div>
</form>
